import { Crest } from '@/components/shared/Crest';

interface Props {
  text: string;
}

export function EmptyState({ text }: Props) {
  return (
    <div className="py-12 text-center text-mute">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-[18px] bg-paper shadow-bt">
        <Crest size={40} variant="gold" />
      </div>
      <p className="text-sm font-medium text-ink-soft">{text}</p>
    </div>
  );
}
